<div class="qu-container">

  <!-- ─── Header ─── -->
  <div class="qu-header">
    <div class="qu-header-left">
      <span class="material-icons qu-header-icon" aria-hidden="true">history</span>
      <div>
        <h2 class="qu-title">{{ 'CB_TRAINING_HISTORY' | translate }}</h2>
        <p class="qu-subtitle">{{ 'CB_TRAINING_HISTORY_SUBTITLE' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- ─── Filter Bar ─── -->
  <div class="qu-action-bar th-filter-bar">
    <div class="th-filters">
      <div class="th-filter">
        <label class="qu-label">Status</label>
        <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()" class="qu-select">
          <option value="">All</option>
          <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
        </select>
      </div>

      <div class="th-filter">
        <label class="qu-label">From</label>
        <input type="date" [(ngModel)]="filterDateFrom" (ngModelChange)="onFilterChange()" class="qu-input th-date" />
      </div>

      <div class="th-filter">
        <label class="qu-label">To</label>
        <input type="date" [(ngModel)]="filterDateTo" (ngModelChange)="onFilterChange()" class="qu-input th-date" />
      </div>

      <div class="th-filter">
        <label class="qu-label">User ID</label>
        <input type="text" [(ngModel)]="filterUser" (ngModelChange)="onFilterChange()"
               placeholder="Created by..." class="qu-input th-user" />
      </div>

      <button *ngIf="hasFilters()" class="qu-btn qu-btn-secondary" (click)="clearFilters()">Clear</button>
    </div>

    <div class="btn-group">
      <button class="qu-btn qu-btn-secondary" (click)="fetchData()">Refresh</button>
    </div>
  </div>

  <!-- ─── Table ─── -->
  <div class="qu-table-wrap">

    <!-- Skeleton (loading) -->
    <table *ngIf="loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th">Task ID</th>
          <th class="qu-th">Type</th>
          <th class="qu-th">Rows</th>
          <th class="qu-th">Status</th>
          <th class="qu-th">Created By</th>
          <th class="qu-th">Created At</th>
          <th class="qu-th">Started At</th>
          <th class="qu-th">Completed At</th>
          <th class="qu-th">Details</th>
          <th class="qu-th">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sk of skeletonRows" class="qu-skeleton-row">
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- Data Table -->
    <table *ngIf="!loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th">Task ID</th>
          <th class="qu-th">Type</th>
          <th class="qu-th">Rows</th>
          <th class="qu-th">Status</th>
          <th class="qu-th">Created By</th>
          <th class="qu-th">Created At</th>
          <th class="qu-th">Started At</th>
          <th class="qu-th">Completed At</th>
          <th class="qu-th">Details</th>
          <th class="qu-th">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of data; let idx = index"
          class="qu-tr"
          [ngClass]="getRowClass(idx)">

          <td class="qu-td qu-td-num">
            {{ row.id }}
            <span *ngIf="row.parentTaskId" class="th-retry-tag" title="Retry of task #{{ row.parentTaskId }}">↻ {{ row.parentTaskId }}</span>
          </td>
          <td class="qu-td">
            <span class="type-badge">{{ row.processType }}</span>
          </td>
          <td class="qu-td">{{ row.totalRows }}</td>
          <td class="qu-td">
            <span class="status-badge" [ngClass]="getStatusClass(row.status)">
              {{ row.status }}
            </span>
          </td>
          <td class="qu-td">{{ row.createdByName || row.createdBy }}</td>
          <td class="qu-td">{{ row.createdAt | date:'short' }}</td>
          <td class="qu-td">{{ row.startedAt | date:'short' }}</td>
          <td class="qu-td">{{ row.completedAt | date:'short' }}</td>
          <td class="qu-td qu-td-details" [title]="row.details || ''">
            {{ row.details || '-' }}
          </td>
          <td class="qu-td qu-td-action">
            <button class="qu-icon-btn qu-icon-btn-view" (click)="viewDetails(row)" title="View details">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </button>
            <button *ngIf="row.status === 'FAILED'" class="qu-icon-btn qu-icon-btn-retry" (click)="retryTask(row)" title="Retry task">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
              </svg>
            </button>
            <button *ngIf="row.status === 'PENDING'" class="qu-icon-btn qu-icon-btn-cancel" (click)="confirmCancel(row)" title="Cancel task">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
            </button>
          </td>
        </tr>

        <tr *ngIf="data.length === 0">
          <td colspan="10" class="qu-td qu-td-empty">No history found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── Pagination (server-side) ─── -->
  <div class="qu-pagination">
    <div class="qu-page-nav">
      <button class="qu-btn qu-btn-page" [disabled]="page === 1" (click)="goToPage(page - 1)">Prev</button>
      <button class="qu-btn qu-btn-page" [disabled]="page >= totalPages" (click)="goToPage(page + 1)">Next</button>
      <span class="qu-page-info">Page {{ page }} of {{ totalPages }}</span>
    </div>

    <span class="qu-count">
      {{ totalRows }} tasks
    </span>

    <div class="qu-rows-wrap">
      <span class="qu-label">Rows per page</span>
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="onPageSizeChange()" class="qu-select">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>

</div>

<!-- ─── View Details Modal ─── -->
<div *ngIf="showDetailModal" class="qu-overlay" (click)="closeDetailModal()">
  <div class="qu-modal th-detail-modal" (click)="$event.stopPropagation()">
    <div class="th-detail-header">
      <h3 class="th-detail-title">Task #{{ detailTask?.id }} — {{ detailTask?.processType }}</h3>
      <button class="qu-clear-btn th-close-btn" (click)="closeDetailModal()">&#x2715;</button>
    </div>

    <div class="th-detail-meta" *ngIf="detailTask">
      <span class="status-badge" [ngClass]="getStatusClass(detailTask.status)">{{ detailTask.status }}</span>
      <span class="th-meta-item">Rows: {{ detailTask.totalRows }}</span>
      <span class="th-meta-item">By: {{ detailTask.createdByName || detailTask.createdBy }}</span>
      <span class="th-meta-item">Created: {{ detailTask.createdAt | date:'short' }}</span>
      <span class="th-meta-item" *ngIf="detailTask.completedAt">Completed: {{ detailTask.completedAt | date:'short' }}</span>
    </div>
    <p class="th-detail-details" *ngIf="detailTask?.details">{{ detailTask?.details }}</p>

    <div *ngIf="detailLoading" class="th-detail-loading">Loading payload rows…</div>

    <div *ngIf="!detailLoading" class="th-payload-wrap">
      <table class="qu-table">
        <thead>
          <tr>
            <th class="qu-th">#</th>
            <th class="qu-th">Question</th>
            <th class="qu-th">Answer</th>
            <th class="qu-th">Abusive</th>
            <th class="qu-th">Operation</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of detailPayloads; let i = index" [ngClass]="getRowClass(i)">
            <td class="qu-td qu-td-num">{{ i + 1 }}</td>
            <td class="qu-td th-payload-text">{{ p.question }}</td>
            <td class="qu-td th-payload-text">{{ p.answer }}</td>
            <td class="qu-td">{{ p.isAbusive ? 'Yes' : 'No' }}</td>
            <td class="qu-td"><span class="type-badge">{{ p.operationType }}</span></td>
          </tr>
          <tr *ngIf="detailPayloads.length === 0">
            <td colspan="5" class="qu-td qu-td-empty">No payload rows.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="qu-modal-actions">
      <button class="qu-btn qu-btn-secondary" (click)="closeDetailModal()">Close</button>
    </div>
  </div>
</div>

<!-- ─── Confirm Cancel Modal ─── -->
<div *ngIf="showCancelModal" class="qu-overlay" (click)="showCancelModal = false">
  <div class="qu-modal" (click)="$event.stopPropagation()">
    <p class="qu-modal-msg">
      Are you sure you want to cancel task #{{ cancelTargetRow?.id }}?
      The task will not be processed.
    </p>
    <div class="qu-modal-actions">
      <button class="qu-btn qu-btn-secondary" (click)="showCancelModal = false">Keep Task</button>
      <button class="qu-btn qu-btn-danger" (click)="handleCancel()">Cancel Task</button>
    </div>
  </div>
</div>

<!-- ─── Toasts ─── -->
<div class="qu-toasts">
  <div
    *ngFor="let t of toasts"
    class="qu-toast"
    [ngClass]="t.type === 'success' ? 'qu-toast-success' : 'qu-toast-error'">
    <span class="qu-toast-icon" [ngClass]="t.type === 'success' ? 'qu-icon-success' : 'qu-icon-error'">
      {{ t.type === 'success' ? '✓' : '✕' }}
    </span>
    <span class="qu-toast-text">{{ t.message }}</span>
  </div>
</div>
